/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { SVGProps, useEffect, useState } from "react";
import { Backdrop, Divider, List, ListItem, ListItemButton, styled } from "@mui/material";
import { useDispatch } from "react-redux";
import colors from "../../theme/themeConstants";
import { useNavigate } from "react-router-dom";
import { toggleBurgerMenu } from "store/application/application-action";
import GrayRoundButton from "../buttons/GrayRoundButton";
import BurgerMenuIcons from "./BurgerMenuIcons";
import { routes } from "routes";
import { ReactComponent as CrossIconWhiteOpacity50 } from "components/icons/crossIconWhiteOpacity50.svg";
import { ReactComponent as DiscordIconOutline } from "components/icons/DiscordIconOutline.svg";
import { ReactComponent as RedditIconOutline } from "components/icons/RedditIconOutline.svg";
import { ReactComponent as TwitterIconOutline } from "components/icons/TwitterIconOutline.svg";
import { ReactComponent as InstagramIconOutline } from "components/icons/InstagramIconOutline.svg";
import { ReactComponent as RightArrow } from "components/icons/right_arrow.svg";
import { ReactComponent as FullRedgifsLogo } from "components/icons/fullRedgifsLogo.svg";
import { links } from "components/ads/config/burgerMenu";
import useWindowDimensions from "../../hooks/useWindowDimension";
import { className } from "utils/strings";

import "./BurgerMenu.scss";

const menuItems = [
  {
    text: "Cams",
    Icon: BurgerMenuIcons.RGCams,
    onClick: (isDesktop: boolean) => {
      window.location.href = isDesktop ? links.RGCamsDesktop : links.RGCams;
    },
  },
  {
    text: "Creator Blog",
    Icon: BurgerMenuIcons.HelpCenterIcon,
    url: "https://redgifs-creators.com/",
  },
  {
    text: "Submit Tags",
    Icon: BurgerMenuIcons.SubmitTagsIcon,
    onClick: () => {
      window.location.href = "https://bbciybcronr.typeform.com/to/ixYPtOb5?typeform-source=www.redgifs.com";
    },
  },
  {
    text: "Guidelines",
    Icon: BurgerMenuIcons.GuidelinesIcon,
    url: routes.guidelines(),
  },
  {
    text: "FAQ",
    Icon: BurgerMenuIcons.FAQIcon,
    url: routes.faq(),
  },
  {
    text: "Terms",
    Icon: BurgerMenuIcons.TermsIcon,
    url: routes.terms(),
  },
  {
    text: "Privacy Policy",
    Icon: BurgerMenuIcons.PrivacyIcon,
    url: routes.privacyPolicy(),
  },
  {
    text: "DMCA",
    Icon: BurgerMenuIcons.DMCAIcon,
    url: routes.dmca(),
  },
  {
    text: "2257 Statement",
    Icon: BurgerMenuIcons.StatementIcon,
    url: routes.statement2257(),
  }
] as IMenuItem[];

interface IMenuItem {
  text: string;
  Icon: React.FC<SVGProps<SVGSVGElement>>;
  url?: string;
  onClick?: (isDesktop: boolean) => void;
  isDesktopHidden?: boolean;
}

const BurgerMenu = ({ isBurgerMenuOpen }: { isBurgerMenuOpen: boolean }) => {
  const url = window.location.pathname;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isDesktop = useWindowDimensions();

  const transformURL = (url: string) => {
    if (url !== links.RGCams) {
      return;
    }

    if (isDesktop) {
      // eslint-disable-next-line
      return "https://prtord.com/?siteId=wl3&cobrandId=257522&superCategoryName=&categoryName=&pageName=home&performerName=&prm[psid]=RedGIFs&prm[pstool]=205_1&prm[psprogram]=cbrnd&prm[campaign_id]=&subAffId={SUBAFFID}&prm[utm_source]=menu&filters=";
    }

    return url;
  };

  const handleMenuItemClick = (item: IMenuItem) => () => {
    if (item.onClick) {
      item.onClick(isDesktop);
    }

    if (item.url && item.url.length > 1) {
      if (item.url.indexOf("https://") === 0) {
        window.open(item.url, "_blank");
      } else {
        navigate(item.url);
      }
    }

    handleClose();
  };

  const handleClose = () => {
    dispatch(toggleBurgerMenu());
  };

  return (
    <>
      <Container className="burgerMenu" isBurgerMenuOpen={isBurgerMenuOpen}>
        <FullRedgifsLogoContainer>
          <FullRedgifsLogo />
        </FullRedgifsLogoContainer>
        <CloseButtonContainer>
          <GrayRoundButton img={<CrossIconWhiteOpacity50 />} onClick={handleClose} imgSize="28px" />
        </CloseButtonContainer>

        <BurgerMenuItemsContainer className="menuItems">
          {
            menuItems.map((item, index) => {
              const { Icon } = item;
              return (
                <React.Fragment key={index}>
                  {index !== 0 ? <Divider sx={{
                    borderColor: "white",
                    opacity: 0.15,
                    "@media screen and (min-width: 1170px)": {
                      border: "none",
                    },
                  }} /> : null}
                  { (isDesktop && !item.isDesktopHidden) || !isDesktop ?
                    <ListItemButton
                      onClick={handleMenuItemClick(item)}
                      sx={{
                        padding: "12px 12px 12px 0px",
                        "@media screen and (min-width: 1170px)": {
                          padding: "16px 16px 16px 0px"
                        }
                      }}
                    >
                      <BurgerMenuItem isCurrentPage={url === item.url}>
                        <Icon className="BurgerMenuItemIcon" />
                        <StyledBurgerItemSpan>
                          {item.text}
                        </StyledBurgerItemSpan>
                        <RightArrow className={className({
                          "right": true,
                          "current": url === item.url,
                        })} />
                      </BurgerMenuItem>
                    </ListItemButton>
                    : null
                  }
                </React.Fragment>
              );
            })
          }
        </BurgerMenuItemsContainer>

        <SocialLinksContainer>
          <p style={{
            color: "white",
            opacity: 0.3,
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "22px",
            marginBottom: "6px",
          }}>
            Social:
          </p>
          <SocialFlexContainer>
            <a href="https://discord.gg/w8fTWPn4Eb" target="_blank" rel="noreferrer">
              <DiscordIconOutline />
            </a>
            <a href="http://bit.ly/405rRS7" target="_blank" rel="noreferrer">
              <RedditIconOutline />
            </a>
            <a href="https://bit.ly/405Qdey" target="_blank" rel="noreferrer">
              <TwitterIconOutline />
            </a>
            <a href="https://bit.ly/3naK6an" target="_blank" rel="noreferrer">
              <InstagramIconOutline />
            </a>
          </SocialFlexContainer>
        </SocialLinksContainer>

      </Container >
      <Backdrop
        open
        sx={{
          zIndex: "var(--popupZ)",
          ".desktop &": {
            backgroundColor: "transparent"
          }
        }}
        onClick={handleClose}
        id={"burgerMenu"}
      />
    </>
  );
};

export default BurgerMenu;

const Container = styled("div", { shouldForwardProp: (prop) => prop !== "isBurgerMenuOpen" })<
  { isBurgerMenuOpen: boolean }>(({ isBurgerMenuOpen }) => {
    return {
      width: "67vw",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      padding: "16px 16px 90px",
      position: "fixed",
      right: isBurgerMenuOpen ? 0 : "-50rem",
      border: `1px solid ${colors.lightGray}`,
      top: 0,
      zIndex: 350,
      backgroundColor: colors.backgroundBlack,
      overscrollBehavior: "contain",
      overflowY: "scroll",
      transition: "right 150ms cubic-bezier(0, 0, 1, 1) 0ms",
      WebkitTransition: "right 150ms ease-out 0ms",
      ".BurgerMenuItemIcon": {
        maxHeight: "20px",
        marginRight: "0.5rem",
        padding: 0,
        order: 1,
        "@media screen and (min-width: 900px)": {
          marginLeft: "0.5rem",
        }
      },
      "@media (max-width: 450px)": {
        backgroundColor: colors.cardBackgroundDarkBlue,
        border: "none"
      },
      "@media screen and (min-width: 1170px)": {
        maxWidth: "20vw",
        minWidth: "200px",
        padding: "1rem 1.5rem 1.5rem 2rem",
      },
      "@-moz-document": {
        MozTransition: "right 150ms ease-out 0ms",
        color: "red",
      },
    };
  });

const SocialFlexContainer = styled("div")({
  display: "flex",
  "& svg": {
    width: "25px",
    height: "25px",
    marginRight: "1rem",
  }
});

const CloseButtonContainer = styled("div")({
  right: "1rem",
  position: "absolute",
});

const BurgerMenuItemsContainer = styled(List)({
  "@media screen and (max-width: 900px)": {
    marginTop: "80px",
  }
});

const BurgerMenuItem = styled(ListItem, { shouldForwardProp: (prop) => prop !== "isCurrentPage" })<
  { isCurrentPage: boolean }>(({ isCurrentPage }) => ({
    display: "flex",
    padding: 0,
    justifyContent: "space-between",
    transition: "opacity .3s ease",
    "@media screen and (min-width: 900px)": {
      opacity: !isCurrentPage ? 0.5 : 1,
      "&:hover": {
        opacity: 0.8
      },
    }
  }));

const SocialLinksContainer = styled("div")({
  "@media screen and (min-width: 900px)": {
    marginTop: "auto",
    marginLeft: "1rem",
  }
});

const StyledBurgerItemSpan = styled("span")({
  lineHeight: "24px",
  fontWeight: 500,
  width: "-webkit-fill-available",
  order: 2,
  "@-moz-document url-prefix()": {
    width: "-moz-available",
  },
});

const FullRedgifsLogoContainer = styled("div")({
  ".phone &": {
    top: "5px",
    position: "relative"
  },
  "svg": {
    height: "36px",
    width: "94px",
    ".phone &": {
      height: "auto",
      width: "127px"
    }
  }
});
